<template>
    <div class="tools-tab tools-tab-notes tools-tab-notes--internal">
        <icon name="info" v-tooltip="$t('tooltip.roster.internal')" />
        <textarea v-model="internal" :placeholder="$t('tooltip.roster.internal')" maxlength="500" @keydown="handleKeys" @focus="focus"></textarea>

        <a href="#" class="remove btn btn--red" v-on:click.prevent="remove()" v-if="item.internal">{{ $t('common.button.delete') }}</a>
        <a href="#" class="btn btn--green" v-on:click.prevent="save()">{{ $t('common.button.save') }}</a>
    </div>
</template>

<script>
import events from '../../../events/events';
import shared from '../../../pages/planning/shared';
import { mapState } from 'vuex';

export default
{
    name: 'Internal',

    props: ['item'],

    data() {
        return {
            shared: shared.state,
            internal: '',
        }
    },

    computed:
    {
        ...mapState({
            android: ({ app }) => app.os === 'android'
        })
    },

    created()
    {
        this.internal = this.item.internal;
    },

    methods:
    {
        save(remove)
        {
            let internal = remove ? '' : this.internal;

            this.$http.put(
            '/api/items/' + this.item.id + '/internal', {
                internal: internal // be explicit :)
            })
            .then(response =>
            {
                // update item and local property
                this.item.internal = internal;
                this.internal = internal;

                this.$tools.close();
            });
        },

        remove()
        {
            this.save(true); // remove
        },

        handleKeys(e)
        {
            // no CTRL or CMD key pressed
            if ( ! (e.metaKey || e.ctrlKey)) return;

            let key = e.which || e.keyCode || 0;

            // select all (CTRL+A)
            if (key == 65)
            {
                // prevent roster items from being selected
                e.stopPropagation();
            }
        },

        focus()
        {
            if (this.android) events.$emit('input.focus', true)
        }
    }
}
</script>



// WEBPACK FOOTER //
// Internal.vue?629b3718